export default {
  default: () => import("/codebuild/output/src545853651/src/src/layouts/default.vue").then(m => m.default || m)
}